/**
 * Fetches public runtime config (currently just the Turnstile site key) so the
 * SPA needs no build-time environment wiring — the same bundle works in dev and
 * production.
 */
import { useEffect, useState } from 'react';

interface Config {
  turnstileSiteKey: string;
}

let cached: Config | null = null;

export function useConfig(): Config {
  const [config, setConfig] = useState<Config>(cached ?? { turnstileSiteKey: '' });

  useEffect(() => {
    if (cached) return;
    let active = true;

    fetch('/api/config')
      .then((r) => (r.ok ? r.json() : null))
      .then((data: Config | null) => {
        if (!data || !active) return;
        cached = data;
        setConfig(data);
      })
      .catch(() => {
        // Turnstile simply won't render; the server still rejects the request,
        // so this fails closed rather than silently bypassing the check.
      });

    return () => {
      active = false;
    };
  }, []);

  return config;
}
